module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"detail":"详情","buy_now":"立即购买"}}')
  delete Component.options._Ctor
}
